import { ref } from 'vue'

// Global state for login dialog
const showLoginDialog = ref(false)
const intendedRoute = ref('')

export const useLoginDialog = () => {
	const showDialog = (route = '') => {
		intendedRoute.value = route
		showLoginDialog.value = true
	}

	const hideDialog = () => {
		showLoginDialog.value = false
		intendedRoute.value = ''
	}

	const onLoginSuccess = () => {
		hideDialog()
		// Additional success handling can be added here
	}

	const onCancelled = () => {
		hideDialog()
		// Additional cancellation handling can be added here
	}

	return {
		showLoginDialog,
		intendedRoute,
		showDialog,
		hideDialog,
		onLoginSuccess,
		onCancelled
	}
}